import { FormItemType } from '../enums'
import {
  ALLOWED_FILE_MIME_TYPE_EXTENSION_MAP,
  ATTACHMENT_MAX_FILE_SIZE_BYTES,
} from '../validationConfig'

export const FORM_ITEMS = {
  [FormItemType.File]: {
    maxFormCount: 20,
    maxSurveyCount: 1,
    maxSize: ATTACHMENT_MAX_FILE_SIZE_BYTES,
    allowedMimeTypes: ALLOWED_FILE_MIME_TYPE_EXTENSION_MAP,
  },
}
